// Generated from java-escape by ANTLR 4.11.1
// jshint ignore: start
import * as antlr4 from 'antlr4';

// This class defines a complete generic visitor for a parse tree produced by DataParser.

export default class DataParserVisitor extends antlr4.ParseTreeVisitor {

	// Visit a parse tree produced by DataParser#line.
	visitLine(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by DataParser#Concat.
	visitConcat(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by DataParser#Expr.
	visitExpr(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by DataParser#Text.
	visitText(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by DataParser#ConcatParens.
	visitConcatParens(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by DataParser#Upper.
	visitUpper(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by DataParser#Replace.
	visitReplace(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by DataParser#Lower.
	visitLower(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by DataParser#AddDays.
	visitAddDays(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by DataParser#MulDiv.
	visitMulDiv(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by DataParser#AddSub.
	visitAddSub(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by DataParser#Parens.
	visitParens(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by DataParser#Parse.
	visitParse(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by DataParser#Num.
	visitNum(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by DataParser#Neg.
	visitNeg(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by DataParser#Field.
	visitField(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by DataParser#Get.
	visitGet(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by DataParser#GetEndDate.
	visitGetEndDate(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by DataParser#GetDateRange.
	visitGetDateRange(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by DataParser#GetStartDate.
	visitGetStartDate(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by DataParser#getStartDateFunc.
	visitGetStartDateFunc(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by DataParser#getEndDateFunc.
	visitGetEndDateFunc(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by DataParser#getDateRangeFunc.
	visitGetDateRangeFunc(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by DataParser#addDaysFunc.
	visitAddDaysFunc(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by DataParser#replaceFunc.
	visitReplaceFunc(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by DataParser#getAspectFunc.
	visitGetAspectFunc(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by DataParser#parseFunc.
	visitParseFunc(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by DataParser#lowerFunc.
	visitLowerFunc(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by DataParser#upperFunc.
	visitUpperFunc(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by DataParser#stringTerm.
	visitStringTerm(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by DataParser#intTerm.
	visitIntTerm(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by DataParser#args.
	visitArgs(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by DataParser#name.
	visitName(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by DataParser#term.
	visitTerm(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by DataParser#literal.
	visitLiteral(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by DataParser#int.
	visitInt(ctx) {
	  return this.visitChildren(ctx);
	}



}